export default function lock(o: unknown): unknown {
  Object.freeze(o);
  if (o === undefined) {
    return o;
  }
  const conf = o as Record<string, unknown>;
  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (
      conf[prop] !== null &&
      (typeof conf[prop] === 'object' || typeof conf[prop] === 'function') &&
      !Object.isFrozen(conf[prop])
    ) {
      lock(conf[prop]);
    }
  });

  return o;
}
